
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("gEKYJ"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("gEKYJ", function(module, exports) {

let $c204d2b61305dc6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c204d2b61305dc6f$var$load("cRtGo"),
    $c204d2b61305dc6f$var$load("3Zwna"),
    $c204d2b61305dc6f$var$load("kWfvZ"),
    $c204d2b61305dc6f$var$load("jlJSm"),
    $c204d2b61305dc6f$var$load("55OBD"),
    $c204d2b61305dc6f$var$load("6EBLs"),
    $c204d2b61305dc6f$var$load("d1wKq"),
    $c204d2b61305dc6f$var$load("27glK"),
    $c204d2b61305dc6f$var$load("bvY53"),
    $c204d2b61305dc6f$var$load("l8Ar8"),
    $c204d2b61305dc6f$var$load("gFEtJ"),
    $c204d2b61305dc6f$var$load("7jSfd"),
    $c204d2b61305dc6f$var$load("4HZlX"),
    $c204d2b61305dc6f$var$load("kDqHr"),
    $c204d2b61305dc6f$var$load("gT8XU"),
    $c204d2b61305dc6f$var$load("3GuOt"),
    $c204d2b61305dc6f$var$load("3Mspc"),
    $c204d2b61305dc6f$var$load("9aQIt"),
    $c204d2b61305dc6f$var$load("XZauT"),
    $c204d2b61305dc6f$var$load("4S1SF"),
    $c204d2b61305dc6f$var$load("lm9Lt"),
    $c204d2b61305dc6f$var$load("9wPDc"),
    $c204d2b61305dc6f$var$load("1MWOL"),
    $c204d2b61305dc6f$var$load("6fQco"),
    $c204d2b61305dc6f$var$load("aOY32"),
    $c204d2b61305dc6f$var$load("3MYQs"),
    $c204d2b61305dc6f$var$load("6SWFK"),
    $c204d2b61305dc6f$var$load("5zapo"),
    $c204d2b61305dc6f$var$load("jiFtb"),
    $c204d2b61305dc6f$var$load("9atVd"),
    $c204d2b61305dc6f$var$load("iivLa"),
    $c204d2b61305dc6f$var$load("6wr18"),
    $c204d2b61305dc6f$var$load("dek7I"),
    $c204d2b61305dc6f$var$load("6iz6l"),
    $c204d2b61305dc6f$var$load("4SCW2"),
    $c204d2b61305dc6f$var$load("fdKpi"),
    $c204d2b61305dc6f$var$load("ffEVr"),
    $c204d2b61305dc6f$var$load("hhss7"),
    $c204d2b61305dc6f$var$load("l22f4"),
    $c204d2b61305dc6f$var$load("eTYdV"),
    $c204d2b61305dc6f$var$load("Wowvf"),
    $c204d2b61305dc6f$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("kxO4K"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("kxO4K", function(module, exports) {

let $ef4dbbac423a979c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4dbbac423a979c$var$load("cRtGo"),
    $ef4dbbac423a979c$var$load("3Zwna"),
    $ef4dbbac423a979c$var$load("6wr18"),
    $ef4dbbac423a979c$var$load("3j4Bc"),
    $ef4dbbac423a979c$var$load("27glK"),
    $ef4dbbac423a979c$var$load("bvY53"),
    $ef4dbbac423a979c$var$load("ffEVr"),
    $ef4dbbac423a979c$var$load("fIjMV"),
    $ef4dbbac423a979c$var$load("psI7s"),
    $ef4dbbac423a979c$var$load("j3SHq"),
    $ef4dbbac423a979c$var$load("dfFoa"),
    $ef4dbbac423a979c$var$load("eTYdV"),
    $ef4dbbac423a979c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("f4Uwj"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("f4Uwj", function(module, exports) {

let $afa3127b8713a7b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afa3127b8713a7b3$var$load("1rQeu"),
    $afa3127b8713a7b3$var$load("h3ABO"),
    $afa3127b8713a7b3$var$load("2oPKP"),
    $afa3127b8713a7b3$var$load("gSg0R"),
    $afa3127b8713a7b3$var$load("4y0IB"),
    $afa3127b8713a7b3$var$load("iEUHW"),
    $afa3127b8713a7b3$var$load("kbwlB"),
    $afa3127b8713a7b3$var$load("2YffH"),
    $afa3127b8713a7b3$var$load("9XOeB"),
    $afa3127b8713a7b3$var$load("xu7ej"),
    $afa3127b8713a7b3$var$load("iQ4FP"),
    $afa3127b8713a7b3$var$load("5qTVP"),
    $afa3127b8713a7b3$var$load("grTPo"),
    $afa3127b8713a7b3$var$load("73TmC"),
    $afa3127b8713a7b3$var$load("9anPW"),
    $afa3127b8713a7b3$var$load("7VVIa"),
    $afa3127b8713a7b3$var$load("6wmiZ"),
    $afa3127b8713a7b3$var$load("im1VN"),
    $afa3127b8713a7b3$var$load("eD3Si"),
    $afa3127b8713a7b3$var$load("f69R7"),
    $afa3127b8713a7b3$var$load("85ppg"),
    $afa3127b8713a7b3$var$load("7iwAE"),
    $afa3127b8713a7b3$var$load("gnDXu"),
    $afa3127b8713a7b3$var$load("5XC9j"),
    $afa3127b8713a7b3$var$load("kWfvZ"),
    $afa3127b8713a7b3$var$load("jlJSm"),
    $afa3127b8713a7b3$var$load("6EBLs"),
    $afa3127b8713a7b3$var$load("d1wKq"),
    $afa3127b8713a7b3$var$load("l8Ar8"),
    $afa3127b8713a7b3$var$load("lTK3c"),
    $afa3127b8713a7b3$var$load("1WXdc"),
    $afa3127b8713a7b3$var$load("b2FtX"),
    $afa3127b8713a7b3$var$load("9AMyR"),
    $afa3127b8713a7b3$var$load("eKJoG"),
    $afa3127b8713a7b3$var$load("6iz6l"),
    $afa3127b8713a7b3$var$load("4SCW2"),
    $afa3127b8713a7b3$var$load("7BON9"),
    $afa3127b8713a7b3$var$load("Y2vgz"),
    $afa3127b8713a7b3$var$load("c0JsV"),
    $afa3127b8713a7b3$var$load("breTf"),
    $afa3127b8713a7b3$var$load("5bb7O"),
    $afa3127b8713a7b3$var$load("AJVgg"),
    $afa3127b8713a7b3$var$load("bJaqQ"),
    $afa3127b8713a7b3$var$load("cRtGo"),
    $afa3127b8713a7b3$var$load("6wr18"),
    $afa3127b8713a7b3$var$load("jvHRs"),
    $afa3127b8713a7b3$var$load("27glK"),
    $afa3127b8713a7b3$var$load("bvY53"),
    $afa3127b8713a7b3$var$load("5NQgH"),
    $afa3127b8713a7b3$var$load("hhss7"),
    $afa3127b8713a7b3$var$load("Wowvf"),
    $afa3127b8713a7b3$var$load("ffEVr"),
    $afa3127b8713a7b3$var$load("fIjMV"),
    $afa3127b8713a7b3$var$load("psI7s"),
    $afa3127b8713a7b3$var$load("j3SHq"),
    $afa3127b8713a7b3$var$load("dfFoa"),
    $afa3127b8713a7b3$var$load("jnVKv"),
    $afa3127b8713a7b3$var$load("3Zwna"),
    $afa3127b8713a7b3$var$load("7EorR"),
    $afa3127b8713a7b3$var$load("bgHzk"),
    $afa3127b8713a7b3$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.144cd139.js.map
